'use client';

import { PropsWithChildren } from 'react';
import { Box, Stack } from '@/primitives';
import { usePathname } from 'next/navigation';
import {
  FOOTER_HEIGHT,
  MOBILE_FOOTER_HEIGHT,
  NAV_HEIGHT,
} from '@/configs/layout';
import { isPublicSearchResultsPath } from '@/lib/publicSearchPaths';

export default function SocietyPublicSearchLayout({
  children,
}: PropsWithChildren) {
  const pathname = usePathname();
  const isMemberDetail = /\/members\/.+/.test(pathname);
  const isAnimalDetail =
    /\/animals\/.+/.test(pathname) &&
    !/\/animals\/(mating|ebv-percentages)(\/|$)/.test(pathname);
  const isLotDetail = /\/sales\/[^/]+\/lots\/[^/]+\/?$/.test(pathname);
  const isEntityDetailPage = isMemberDetail || isAnimalDetail || isLotDetail;
  const isResultsPage = isPublicSearchResultsPath(pathname);

  return (
    <Stack
      direction="column"
      sx={{
        flex: 1,
        gap: { xs: '6px', md: '12px' },
        px: { xs: isEntityDetailPage ? '12px' : '20px', md: '20px' },
        pt: { xs: '2px', md: '3px' },
        pb: 0,
        bgcolor: isEntityDetailPage ? 'background.paper' : 'background.default',
        minHeight: 0,
        maxHeight: {
          xs: `calc(100dvh - ${NAV_HEIGHT}px - ${MOBILE_FOOTER_HEIGHT}px)`,
          md: `calc(100dvh - ${NAV_HEIGHT}px - ${FOOTER_HEIGHT}px)`,
        },
        overflowX: 'hidden',
        // Below md a results page takes its natural height and scrolls here,
        // as the only scroller (the AdminListShell pattern; this shell's
        // <main> does not scroll). Clamped with nothing scrolling, the list
        // got whatever the header left over — a sliver on a phone — and
        // scrolled inside that beside a second scrollbar.
        overflowY: isResultsPage ? { xs: 'auto', md: 'hidden' } : 'hidden',
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: isResultsPage ? { xs: 'auto', md: 0 } : 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Stack>
  );
}
